export const translations = {
  app_title: { fr: "Protocoles Sécurité", en: "Protocoles Sécurité" },
  tagline: { fr: "Protocoles de Sécurité — Chargement / Déchargement", en: "Safety Protocols — Loading / Unloading" },
  nav: {
    dashboard: { fr: "Tableau de Bord", en: "Dashboard" },
    protocols: { fr: "Protocoles", en: "Protocols" },
    create_protocol: { fr: "Créer un Protocole", en: "Create Protocol" },
    referential: { fr: "Référentiel", en: "Referential" },
    translations: { fr: "Traductions", en: "Translations" },
    to_validate: { fr: "À Valider", en: "To Validate" },
    archives: { fr: "Archives", en: "Archives" },
    admin: { fr: "Administration", en: "Administration" },
    help: { fr: "Aide / Tutoriel", en: "Help / Tutorial" },
    privacy: { fr: "Confidentialité", en: "Privacy" },
  },
  statuses: {
    BROUILLON: { fr: "Brouillon", en: "Draft" },
    A_VALIDER: { fr: "À Valider", en: "Under Review" },
    VALIDE: { fr: "Validé", en: "Validated" },
    PUBLIE: { fr: "Publié", en: "Published" },
    OBSOLETE: { fr: "Obsolète", en: "Obsolete" },
  },
  roles: {
    ADMIN: { fr: "Administrateur", en: "Administrator" },
    VALIDATEUR: { fr: "Validateur", en: "Validator" },
    REDACTEUR: { fr: "Rédacteur", en: "Editor" },
  },
  common: {
    login_with_google: { fr: "Se connecter avec Google", en: "Sign in with Google" },
    logout: { fr: "Se déconnecter", en: "Sign out" },
    save: { fr: "Enregistrer", en: "Save" },
    cancel: { fr: "Annuler", en: "Cancel" },
    edit: { fr: "Modifier", en: "Edit" },
    duplicate: { fr: "Dupliquer", en: "Duplicate" },
    submit: { fr: "Soumettre pour validation", en: "Submit for validation" },
    validate: { fr: "Valider", en: "Validate" },
    refuse: { fr: "Refuser", en: "Refuse" },
    publish: { fr: "Publier", en: "Publish" },
    archive: { fr: "Archiver", en: "Archive" },
    new_version: { fr: "Nouvelle version", en: "New version" },
    add_section: { fr: "Ajouter une section", en: "Add section" },
    search: { fr: "Rechercher un protocole ou un ID...", en: "Search a protocol or an ID..." },
    all_sites: { fr: "Tous les sites", en: "All sites" },
    all_operations: { fr: "Toutes les opérations", en: "All operations" },
    all_statuses: { fr: "Tous les statuts", en: "All statuses" },
    no_results: { fr: "Aucun protocole trouvé.", en: "No protocols found." },
    loading: { fr: "Chargement...", en: "Loading..." },
    reason_required: { fr: "Motif (obligatoire)", en: "Reason (required)" },
    reason_optional: { fr: "Motif (optionnel)", en: "Reason (optional)" },
    confirm: { fr: "Confirmer", en: "Confirm" },
    info: { fr: "Informations", en: "Info" },
    sections: { fr: "Sections", en: "Sections" },
    versions: { fr: "Versions", en: "Versions" },
    history: { fr: "Historique", en: "History" },
    version: { fr: "Version", en: "Version" },
    site: { fr: "Site", en: "Site" },
    operation: { fr: "Opération", en: "Operation" },
    title: { fr: "Titre", en: "Title" },
    description: { fr: "Description", en: "Description" },
    due_date: { fr: "Date d'échéance", en: "Due date" },
    author: { fr: "Auteur", en: "Author" },
    created_on: { fr: "Créé le", en: "Created on" },
    updated_on: { fr: "Mis à jour le", en: "Updated on" },
    compliance_score: { fr: "Score de conformité", en: "Compliance score" },
    create: { fr: "Créer", en: "Create" },
    minor: { fr: "Mineure (ex: 2.1 → 2.2)", en: "Minor (e.g. 2.1 → 2.2)" },
    major: { fr: "Majeure (ex: 2.2 → 3.0)", en: "Major (e.g. 2.2 → 3.0)" },
    section_type: { fr: "Type de section", en: "Section type" },
    section_title: { fr: "Titre de la section", en: "Section title" },
    section_content: { fr: "Contenu", en: "Content" },
    remove: { fr: "Supprimer", en: "Remove" },
    access_denied: { fr: "Accès réservé aux administrateurs.", en: "Access restricted to administrators." },
    vehicule_type: { fr: "Type de véhicule", en: "Vehicle type" },
    produit: { fr: "Produit / Matière transportée", en: "Product / Transported material" },
    none: { fr: "Aucun", en: "None" },
    compliance: { fr: "Conformité", en: "Compliance" },
    applicable_rules: { fr: "Règles applicables", en: "Applicable rules" },
    covered: { fr: "Couverte", en: "Couverte" },
    not_covered: { fr: "Non couverte", en: "Not covered" },
    translate_to_en: { fr: "Traduire en anglais (IA)", en: "Translate to English (AI)" },
    translate: { fr: "Traduire (IA)", en: "Translate (AI)" },
    target_language: { fr: "Langue cible", en: "Target language" },
    translating: { fr: "Traduction en cours...", en: "Translating..." },
    translation: { fr: "Traduction générée", en: "Translation generated" },
    translation_failed: { fr: "La traduction IA a échoué, veuillez réessayer", en: "AI translation failed, please retry" },
    translation_timeout: { fr: "La traduction prend plus de temps que prévu, réessayez plus tard", en: "Translation is taking longer than expected, please retry later" },
    download_pdf_en: { fr: "Télécharger le PDF", en: "Download PDF" },
    no_translation_yet: { fr: "Aucune traduction pour le moment.", en: "No translation yet." },
    level: { fr: "Niveau", en: "Level" },
    source: { fr: "Source réglementaire", en: "Regulatory source" },
    no_applicable_rule: { fr: "Aucune règle applicable pour cette combinaison véhicule / opération / produit.", en: "No applicable rule for this vehicle / operation / product combination." },
    tab_rules: { fr: "Règles", en: "Rules" },
    tab_risks: { fr: "Risques", en: "Risks" },
    tab_epi: { fr: "EPI", en: "PPE" },
    tab_vehicles: { fr: "Véhicules", en: "Vehicles" },
    tab_products: { fr: "Produits", en: "Products" },
    all_translations: { fr: "Toutes les traductions", en: "All translations" },
    prefill_from_referentiel: { fr: "Pré-remplir depuis le référentiel", en: "Prefill from referential" },
    prefill_success: { fr: "Sections pré-remplies depuis le référentiel HSE", en: "Sections prefilled from HSE referential" },
    select_vehicle_operation_first: { fr: "Sélectionnez un véhicule et une opération d'abord", en: "Select a vehicle and operation first" },
    prefill_overwrite_confirm: { fr: "Cela remplacera les sections existantes par le contenu du référentiel. Continuer ?", en: "This will replace existing sections with the referential content. Continue?" },
    add_user: { fr: "Ajouter un utilisateur", en: "Add user" },
    add_site: { fr: "Ajouter un site", en: "Add site" },
    email: { fr: "Email", en: "Email" },
    name: { fr: "Nom", en: "Name" },
    role: { fr: "Rôle", en: "Role" },
    address: { fr: "Adresse", en: "Address" },
    user_created: { fr: "Utilisateur créé", en: "User created" },
    user_deleted: { fr: "Utilisateur supprimé", en: "User deleted" },
    site_created: { fr: "Site créé", en: "Site created" },
    site_deleted: { fr: "Site supprimé", en: "Site deleted" },
    confirm_delete_user: { fr: "Supprimer définitivement cet utilisateur ?", en: "Permanently delete this user?" },
    confirm_delete_site: { fr: "Supprimer définitivement ce site ?", en: "Permanently delete this site?" },
    export_excel: { fr: "Exporter (Excel)", en: "Export (Excel)" },
    export_pdf: { fr: "Exporter (PDF)", en: "Export (PDF)" },
    translation_obsolete_warning: { fr: "⚠️ Traduction obsolète : une nouvelle version française a été publiée", en: "⚠️ Obsolete translation: a new French version has been published" },
    retranslate: { fr: "Retraduire", en: "Retranslate" },
    obsolete: { fr: "Obsolète", en: "Obsolete" },
  },
  cadre: {
    title: { fr: "Cadre du protocole", en: "Protocol framework" },
    entreprise_accueil_nom: { fr: "Entreprise d'accueil - Nom", en: "Host company - Name" },
    entreprise_accueil_coordonnees: { fr: "Entreprise d'accueil - Adresse / Contact", en: "Host company - Address / Contact" },
    coordonnees: { fr: "Adresse / Contact", en: "Address / Contact" },
    entreprise_transport_nom: { fr: "Entreprise de transport - Nom", en: "Transport company - Name" },
    entreprise_transport_coordonnees: { fr: "Entreprise de transport - Adresse / Contact", en: "Transport company - Address / Contact" },
    responsable_site_nom: { fr: "Responsable du site", en: "Site manager" },
    responsable_site_fonction: { fr: "Fonction du responsable", en: "Manager's function" },
    fonction: { fr: "Fonction", en: "Function" },
    lieu_operation: { fr: "Lieu de l'opération", en: "Operation location" },
    operation_repetitive: { fr: "Opération répétitive", en: "Repetitive operation" },
    oui: { fr: "Oui", en: "Yes" },
    non: { fr: "Non", en: "No" },
    tonnage_volume: { fr: "Tonnage / Volume", en: "Tonnage / Volume" },
    conditionnement: { fr: "Conditionnement", en: "Packaging" },
    adr_classe: { fr: "Classe matière (ADR)", en: "Material class (ADR)" },
    adr_code_danger: { fr: "Code de danger", en: "Danger code" },
    adr_numero_onu: { fr: "N° ONU", en: "UN number" },
    adr_groupe_emballage: { fr: "Groupe d'emballage", en: "Packing group" },
    materiel_disposition: { fr: "Matériel mis à disposition", en: "Equipment provided" },
    urgence_numero_site: { fr: "N° d'urgence du site", en: "Site emergency number" },
    plan_circulation: { fr: "Plan de circulation du site", en: "Site traffic plan" },
    plan_circulation_view: { fr: "Voir le plan de circulation", en: "View traffic plan" },
    plan_circulation_empty: { fr: "Aucun plan de circulation joint pour le moment.", en: "No traffic plan attached yet." },
    plan_circulation_upload: { fr: "Joindre un plan (PDF/image)", en: "Attach a plan (PDF/image)" },
    plan_circulation_uploaded: { fr: "Plan de circulation enregistré", en: "Traffic plan saved" },
    import_fds_termine: { fr: "Import FDS/FHD terminé", en: "FDS/FHD import complete" },
    import_fds_resume: { fr: "{produits} produits créés, {dangers} dangers créés, {erreurs} erreurs", en: "{produits} products created, {dangers} hazards created, {erreurs} errors" },
  },
};
